import { MetricPayload, UNKNOWN_METRICS_VALUE } from "../models/metric-model";
import { createAuthorisedApiRequest } from "../helpers/create-authorised-request";
import { fetchWrapper } from "../helpers/fetch-wrapper";
import { getDiagnostics } from "../helpers/DiagnosticsHelper";

export const AttachFilesMetricActionConsts = {
    search: "search",
    cancel: "cancel",
    clearSelected: "clear selected",
    selectFolder: "select folder",
    showEmail: "show email",
    hideEmail: "hide email",
} as const;
  
// Extract the values of AttachFilesMetricActionConsts
type AttachFilesMetricActionType = typeof AttachFilesMetricActionConsts[keyof typeof AttachFilesMetricActionConsts];

export async function logAttachFilesUsageMetric(action: AttachFilesMetricActionType): Promise<void> {
    const metricName = "outlook_addin_attach_files_usage";

    try {
        const diagnostics = getDiagnostics();

        const metricPayload: MetricPayload = {
            Metric: {
                Name: metricName,
                Timestamp: new Date().toISOString(), // Current UTC time
                Dimensions: {
                    Platform: diagnostics?.platform || UNKNOWN_METRICS_VALUE,
                    Version: diagnostics?.version || UNKNOWN_METRICS_VALUE,
                    HostName: diagnostics?.hostName || UNKNOWN_METRICS_VALUE,
                    HostVersion: diagnostics?.hostVersion || UNKNOWN_METRICS_VALUE,
                    Action: action,
                    Product: ""
                },
            },
        };

        const { url, requestInit } = await createAuthorisedApiRequest("AddMetricUrl", metricPayload);
        const result = await fetchWrapper(url, requestInit);

        if (result.err) {
            console.error(`Add metric call returned an error when saving ${metricName} metric: `, result.err);
        }
      } catch (error) {
          console.error(`Error occurred when saving ${metricName} metric: `, error);
      }
  }